module.exports = __webpack_public_path__ + "static/media/(000083).6f58fd79.jpg";